import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/front_en.json';
import fr from './locales/front_fr.json';

const browserLang = (navigator.language || navigator.userLanguage || 'en').split('-')[0];

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: browserLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
